var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-view pa-1",class:{ 'pl-7': _vm.$vuetify.breakpoint.lgAndUp }},[_c('span',{staticClass:"fonte fonteMini grey--text"},[_vm._v(" tags: ")]),_c('sale',{attrs:{"dataOrigin":_vm.dataOrigin,"dataSale":_vm.dataSale}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }